import Game from './src/Game'

const game = new Game();
game.play();
